import Colortheme from '../../Theme/Colortheme.json';

const Timer = props => {
    return <div style={{
        width: props.size,
        height: props.size,
        minWidth: props.size,
        minHeight: props.size,
        background: Colortheme.buttonColor,
        borderRadius: '100%',
        color: 'black',
        fontWeight: 'bold',
        textAlign: 'center',
        border: '2px solid black',
        lineHeight: props.size
    }}>
        {props.timeLeft}
    </div>
}

export default Timer;